import { render, staticRenderFns } from "./LifeToggle.vue?vue&type=template&id=8dcc71c8&scoped=true&"
import script from "./LifeToggle.vue?vue&type=script&lang=js&"
export * from "./LifeToggle.vue?vue&type=script&lang=js&"
import style0 from "./LifeToggle.vue?vue&type=style&index=0&id=8dcc71c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcc71c8",
  null
  
)

export default component.exports